// Note: The first file of a module here, must also register the module

import "./field-icon.component";
import "./field-lists.component";
import "./field-list-item.component";
import "./fields-directory.component";
